<template lang="pug">
  dv-server-form(
    v-model="formData"
    :schema="schema"
    :method="upsert"
    :serialize-data="(resp) => resp.item"
    :success-callback="onUpsertSuccess"
    v-slot="{ submit, fields, formData, loading }"
  )
    div.d-contents
      slot(
        name="default"
        :fields="fields"
      )
        v-row
          v-col(
            v-for="(field, key) in fields"
            :key="key"
            cols="12"
          )
            dv-form-field(
              :field="field"
            )

      slot(
        name="actions"
        :loading="loading"
        :submit="submit"
      )
        v-row
          v-col(cols="12")
            dv-btn(
              :loading="loading"
              type="submit"
              large
            )
              span Сохранить
</template>

<script>
import DvBtn from '../../buttons/DvBtn.vue';
import DvServerForm from '../../forms/DvServerForm.vue';
import DvFormField from '../../forms/DvFormField.vue';

export default {
  components: {
    DvBtn,
    DvServerForm,
    DvFormField,
  },
  props: {
    method: {
      type: Function,
      required: true,
    },
    schema: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  watch: {
    value(val) {
      this.formData = val;
    },
  },
  computed: {
    isEdit() {
      return !!this.formData?.id;
    },
  },
  methods: {
    upsert() {
      const { isEdit, formData } = this;

      const payload = {
        ...isEdit ? { args: [formData.id] } : [],
        data: formData,
      };

      return this.method(payload);
    },
    onUpsertSuccess({ data: item, reset }) {
      const { isEdit } = this;

      this.$emit('success', { isEdit, item });
      reset({});
    },
  },
};
</script>
